module.exports = __webpack_public_path__ + "static/markmiller-2ed40249c3e939eca31990a06af16383.png";